import React from "react";
import { Breadcrumb } from "antd";
import { isFunction } from "../../util/";
import { Metrics } from "../../theme";
/**
 * Breadcrumb that call onclick instead of href
 * @param {array} path 
 * @param {string} seperator
 */
export const BreadcrumbPath = ({
	path = [{
		text:"Path",
		value:"path", 
		onClick: (item, stackValue)=>{
			console.log({item, stackValue});
		}
	}], 
	style,
	seperator=">",
	overflowDots = true,
	id,
})=>{
	const stackValue = [];
	return (
		<div id={id} style={{marginBottom:Metrics.button.mediumSpaceMargin, ...style}}>
			<Breadcrumb separator={seperator} style={overflowDots ? {
				whiteSpace:"nowrap",
				textOverflow:"ellipsis",
				overflow:"hidden"
			} : undefined}>
				{path.map((item,index)=>{
					stackValue.push(item.value);
					const canClick = isFunction(item.onClick);
					const itemStyle = {
						fontSize:Metrics.fontSize.bold,
						cursor: canClick ? "pointer" : "auto"
					};
					return <Breadcrumb.Item key={index} 
						style={itemStyle} 
						onClick={canClick ? ()=>{
							item.onClick(item, stackValue.slice(0,index+1));} 
							: undefined}
					>
						{item.text}
					</Breadcrumb.Item>;
				})}
			</Breadcrumb>
		</div>);
};


// WEBPACK FOOTER //
// ./src/components/navigation/OBreadcrumb.js